import { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
import { galleryApi } from '../services/api';
import type { GalleryYear } from '../types';
import YearSelector from './YearSelector';
import Breadcrumb from './Breadcrumb';

export default function Layout() {
  const [years, setYears] = useState<GalleryYear[]>([]);
  const PORTAL_URL = import.meta.env.VITE_PORTAL_URL || 'http://localhost:5173';

  useEffect(() => {
    galleryApi.getYears().then((res) => setYears(res.years)).catch(() => {});
  }, []);

  return (
    <div className="flex min-h-screen flex-col bg-white">
      <header className="border-b border-gray-200 bg-white sticky top-0 z-30">
        <div className="mx-auto max-w-7xl px-4 py-3">
          <div className="flex items-center justify-between">
            <a href="/" className="flex items-center gap-3">
              <img 
                src="/fwo-logo.png" 
                alt="FlyWideOpen" 
                className="h-10" 
              />
              <h1 className="text-xl font-bold text-gray-900">Photo Gallery</h1>
            </a>
            
            <a 
              href={PORTAL_URL}
              className="text-sm font-medium text-fwo-blue hover:text-fwo-blue/80 transition-colors"
            >
              Pilot Portal
            </a>
          </div>
        </div>

        <div className="mx-auto max-w-7xl">
          <YearSelector years={years} />
        </div>
      </header>

      <Breadcrumb />

      <main className="flex-1 mx-auto w-full max-w-7xl px-4 py-6">
        <Outlet />
      </main>

      <footer className="border-t border-gray-200 bg-gray-50">
        <div className="mx-auto max-w-7xl px-4 py-4 text-center text-xs text-gray-500">
          © {new Date().getFullYear()} FlyWideOpen. All rights reserved.
        </div>
      </footer>
    </div>
  );
}
